const routes = [
  {
    path: '/class-register/:slug',
    name: 'ClassRegisterPage',
    duckName: 'ClassRegisterPage',
    loaders: {
      page: () => import('./containers/ClassRegisterPage/ClassRegisterPage'),
      duck: () => import('./ducks/ClassRegisterPage.duck'),
    },
  },
  {
    path: '/organisation/registers',
    name: 'OrganisationRegisterPage',
    auth: true,
    authPage: 'LoginPage',
    loaders: {
      page: () => import('./containers/OrganisationRegisterPage/OrganisationRegisterPage'),
    },
  },
];

export default routes;
